import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pa-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Cím", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Telefon", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Email", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Adószám", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Bankszámlaszám", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Bank neve", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Számlázási cím", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : ($setup.error)
      ? (_openBlock(), _createBlock($setup["ResourceErrorState"], {
          key: 1,
          kind: $setup.error.kind,
          "trace-id": $setup.error.traceId,
          "back-to": "/admin/companies",
          "back-label": "Vissza a cégekhez",
          onRetry: $setup.fetchData
        }, null, 8, ["kind", "trace-id"]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 2,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.company.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createElementVNode("div", null, _toDisplayString($setup.company.address ?? '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createElementVNode("div", null, _toDisplayString($setup.company.phone ?? '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("div", null, _toDisplayString($setup.company.email ?? '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createElementVNode("div", null, _toDisplayString($setup.company.taxNumber ?? '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("div", null, _toDisplayString($setup.company.bankAccount ?? '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createElementVNode("div", null, _toDisplayString($setup.company.bankName ?? '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createElementVNode("div", null, _toDisplayString($setup.company.billingAddress ?? '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Felhasználók")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              headers: $setup.userHeaders,
                              items: $setup.company.users ?? [],
                              density: "compact",
                              "no-data-text": "Nincs felhasználó"
                            }, null, 8, ["items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}